<template>
	<div class="history-detail-container">
		<div class="history-detail-wrap" v-if="currentContact.id > 0">
			<div class="history-detail-header">
				<div class="history-detail-h-item">
					<input type="datetime-local" placeholder="开始时间" v-model="requestParam.start_time">
				</div>
				<div class="history-detail-h-item">
					<input type="datetime-local" placeholder="截至时间" v-model="requestParam.end_time">
				</div>
				<div class="history-detail-h-item">
					<input type="text" placeholder="输入聊天内容" v-model="requestParam.content">
				</div>
				<div class="history-detail-h-item history-detail-h-searce" @click="search">搜索</div>
			</div>
			<div class="history-detail-box" id="history-detail-box">
				<chatting :chatMsg="chatMsg" :allImages="allImages" :chatUser="chatUser" key="history-detail-chatting"></chatting>
			</div>
			<div class="history-detail-tool">
				<div class="history-detail-t-chat" @click="goChat">私聊</div>
				<div class="history-detail-t-page" v-show="chatMsg.length > 0">
					<page-component 
						:dataApi="dataApi" 
						:requestParams="requestParam" 
						@page-call="pageCall($event)" 
						key="histroy-detail-page"
						ref="HistroyDetailPage">
					</page-component>
				</div>
			</div>
		</div>
		<div class="history-detail-empty" v-else>
			<chat-empty showText="选择粉丝或群后查看"></chat-empty>
		</div>
	</div>
</template>

<script>
	import Chatting from '../../components/Chatting.vue'
	import PageComponent from '../../components/PageComponent.vue'
	import ChatEmpty from '../../components/ChatEmpty.vue'
	import {webGetChatRecordList} from '../../network/web/chat-record.js'
	
	export default{
		name:'HistoryDetail',
		components:{
			Chatting,
			PageComponent,
			ChatEmpty
		},
		props:{
			currentContact:{
				type:Object,
				default:{
					id:0,
					pageType: ''
				}
			},
			customList:{
				type: Array,
				default: []
			}
		},
		data(){
			return{
				allImages:[],
				chatMsg:[],
				dataApi: webGetChatRecordList,
				requestParam:{
					content: '',
					start_time:'',
					end_time:'',
					id: 0,
					type: '',
					prePage: 20
				},
				chatUser:{
					custom_id: 0,
					custom_wx_id: '',
					custom_wx_name: '',
					custom_wx_photo: '',
					fans_id: 0,
					fans_wx_id: '',
					fans_wx_name: '',
					fans_wx_photo: '',
					type: 0
				}
			}
		},
		methods:{
			// 分页数据回调
			pageCall(data){
				if(this.chatUser.type === 2){
					for (var i = 0; i < data.length; i++) {
						data[i].is_me = data[i].from_id == this.chatUser.custom_wx_id?1:0
					}
				}
				this.chatMsg = data
				this.$nextTick(()=>{
					document.getElementById('history-detail-box').scrollTop = 0
				})
			},
			
			// 客服变化时，渲染当前页面对应的粉丝和客服信息
			drawChatUser(fans){
				let custom_id = 0
				// 处理粉丝
				this.chatUser.fans_id = fans.id
				if(fans.pageType === 'fans'){
					this.chatUser.fans_wx_id = fans.open_id
					this.chatUser.fans_wx_name = fans.wx_name
					this.chatUser.fans_wx_photo = fans.wx_photo
					this.chatUser.type = 1
					custom_id = fans.custom_id
				}else{
					this.chatUser.fans_wx_id = fans.wechat_cluster_id
					this.chatUser.fans_wx_name = fans.cluster_name
					this.chatUser.fans_wx_photo = fans.cluster_photo
					this.chatUser.type = 2
					custom_id = fans.custom_id
				}
				// 处理客服信息
				for (var i = 0; i < this.customList.length; i++) {
					if(this.customList[i].id == custom_id){
						this.chatUser.custom_id = custom_id
						this.chatUser.custom_wx_id = this.customList[i].open_id
						this.chatUser.custom_wx_name = this.customList[i].wx_name
						this.chatUser.custom_wx_photo = this.customList[i].wx_photo
						break;
					}
					
				}
			},
			
			// 搜索
			search(){
				this.$refs.HistroyDetailPage.initPage()
			},
			
			// 跳转聊天页面
			goChat(){
				let query = {}
				if(this.chatUser.type === 1){
					query = {
						c_id: this.chatUser.custom_id,
						c_wxid: this.chatUser.custom_wx_id,
						f_wxid: this.chatUser.fans_wx_id,
						type: 'fans'
					}
				}else{
					query = {
						c_id: this.chatUser.custom_id,
						c_wxid: this.chatUser.custom_wx_id,
						f_wxid: this.chatUser.fans_id,
						type: 'cluster'
					}
				}
				
				this.$router.push({
					path: '/chat/chat',
					query:query
				})
			}
		},
		
		watch:{
			// 监听当前粉丝的变化
			currentContact(nVal,oVal){
				this.drawChatUser(nVal)
				this.requestParam.id = nVal.id
				this.requestParam.type = nVal.pageType
				if(oVal.id !== 0){
					this.$refs.HistroyDetailPage.initPage()
				}
			}
		}
	}
</script>

<style>
	.history-detail-container{
		height: 100%;
		position: relative;
		overflow: hidden;
		border-left: 1px solid #CCCCCC;
	}
	.history-detail-container .history-detail-wrap{
		position: relative;
		height: 100%;
	}
	.history-detail-wrap .history-detail-header{
		height: 28px;
		border-bottom: 1px solid #cfcfcf;
		padding: 11px 10px 10px 10px;
		display: flex;
		justify-content: flex-start;
		flex-wrap: nowrap;
	}
	.history-detail-header .history-detail-h-item{
		height: 28px;
		margin: 0 2px;
	}
	.history-detail-h-item input{
		height: 26px;
		line-height: 26px;
		width: 170px;
		border: 1px solid #CCCCCC;
		padding: 0 5px;
		border-radius: 2px;
		color: #666666;
	}
	.history-detail-h-searce{
		padding: 0 10px;
		line-height: 28px;
		background-color: #009688;
		color: #FFFFFF;
		border-radius: 2px;
		cursor: pointer;
	}
	.history-detail-wrap .history-detail-box{
		position: absolute;
		top: 50px;
		left: 0;
		right: 0;
		bottom: 60px;
		overflow-x: hidden;
		overflow-y: auto;
		border-bottom: 1px solid #CCCCCC;
	}
	.history-detail-wrap .history-detail-tool{
		position: absolute;
		height: 30px;
		bottom: 0;
		left: 0;
		right: 0;
		padding: 15px 10px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.history-detail-tool .history-detail-t-chat{
		background-color: #009688;
		line-height: 26px;
		padding: 0 10px;
		color: #FFFFFF;
		cursor: pointer;
		border-radius: 2px;
	}
	.history-detail-tool .history-detail-t-page{
		flex-grow: 1;
		width: 0;
		height: 26px;
	}
	.history-detail-empty{
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 1;
	}
</style>
